// Admin page loaders - these will be loaded dynamically with the pages
// These wrapper functions import and execute the actual loaders

export const adminMetricsLoader = async (args: any) => {
    const module = await import("../pages/admin/AdminMetrics");
    // React Router always passes args, loaders can ignore them if not needed
    // Use type assertion to handle loaders that don't expect arguments
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminSendNewsletterLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminSendNewsletterPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminSendNewsletterAction = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminSendNewsletterPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminScheduledNewslettersLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminScheduledNewslettersPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const loadArticleToEdit = async (args: any) => {
    const module = await import("../pages/admin/blog/AdminCreateOrEditBlogArticlePage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const createOrEditBlogArticleAction = async (args: any) => {
    const module = await import("../pages/admin/blog/AdminCreateOrEditBlogArticlePage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminBlogArticlesLoader = async (args: any) => {
    const module = await import("../pages/admin/blog/AdminBlogPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminAIModelsLoader = async (args: any) => {
    const module = await import("../pages/admin/ai/AdminAIPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminAIAction = async (args: any) => {
    const module = await import("../pages/admin/ai/AdminAIPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminTransactionsLoader = async (args: any) => {
    const module = await import("../pages/admin/TransactionsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const feedbackLoader = async (args: any) => {
    const module = await import("../pages/admin/feedback/AdminFeedbackPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminMetricsAnalysisLoader = async (args: any) => {
    const module = await import("../pages/admin/AdminMetricsAnalysisPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminMetricsAnalysisAction = async (args: any) => {
    const module = await import("../pages/admin/AdminMetricsAnalysisPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const diagnosticsLoader = async (args: any) => {
    const module = await import("../pages/admin/diagnostic/AdminDiagnosticPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminTracesPageLoader = async (args: any) => {
    const module = await import("../pages/admin/trace/AdminTracesPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminKedExperimentResultsLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminKedExperimentPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminKedOfferAction = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminKedOfferPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminKedMeetingsLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminKedMeetingsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminKedMeetingsAction = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminKedMeetingsPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminCreateKedMeetingLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminCreateOrEditKedMeetingPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminEditKedMeetingLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminCreateOrEditKedMeetingPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminCreateOrEditKedMeetingAction = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminCreateOrEditKedMeetingPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminKedUsersLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminCourseUsersPage");
    return module.adminKedUsersLoader ? await (module.adminKedUsersLoader as any)(args) : null;
};

export const adminPedUsersLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminCourseUsersPage");
    return module.adminPedUsersLoader ? await (module.adminPedUsersLoader as any)(args) : null;
};

export const adminZnUsersLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminCourseUsersPage");
    return module.adminZnUsersLoader ? await (module.adminZnUsersLoader as any)(args) : null;
};

export const adminKedV2UsersLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminCourseUsersPage");
    return module.adminKedV2UsersLoader ? await (module.adminKedV2UsersLoader as any)(args) : null;
};

export const adminSpcUsersLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminCourseUsersPage");
    return module.adminSpcUsersLoader ? await (module.adminSpcUsersLoader as any)(args) : null;
};

export const verifyKedAction = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminKedVerificationPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminKedCrmLoader = async (args: any) => {
    const module = await import("../pages/admin/ked/AdminKedCrmPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminListNewslettersLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminListNewslettersPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminToggleNewsletterAction = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminListNewslettersPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminAddToNewsletterAction = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminAddToNewsletterPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const campaignsLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminNewsletterCampaignsStatisticsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const smsCampaignsLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminSmsCampaignsStatisticsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const followUpsLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminNewsletterFollowUpsStatisticsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const loadExerciseToEdit = async (args: any) => {
    const module = await import("../pages/admin/exercise/AdminCreateOrEditExercisePage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const createOrEditExerciseAction = async (args: any) => {
    const module = await import("../pages/admin/exercise/AdminCreateOrEditExercisePage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminSubjectConfigurationLoader = async (args: any) => {
    const module = await import("../pages/admin/exercise/AdminSubjectConfigurationPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminSubjectConfigurationAction = async (args: any) => {
    const module = await import("../pages/admin/exercise/AdminSubjectConfigurationPage");
    return module.action ? await (module.action as any)(args) : null;
};

// Course Gamification Config
export const adminCourseGamificationConfigLoader = async (args: any) => {
    const module = await import("../pages/admin/course-gamification/AdminCourseGamificationConfigPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminCourseGamificationConfigAction = async (args: any) => {
    const module = await import("../pages/admin/course-gamification/AdminCourseGamificationConfigPage");
    return module.action ? await (module.action as any)(args) : null;
};

export const adminReferralsLoader = async (args: any) => {
    const module = await import("../pages/admin/referrals/AdminReferralsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

// Dynamic Newsletter Management
export const adminMailingListsLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminMailingListsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminTagsLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminTagsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminSegmentsLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminSegmentsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminAutomationsLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminAutomationsPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminEmailTemplatesLoader = async (args: any) => {
    const module = await import("../pages/admin/newsletter/AdminEmailTemplatesPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

export const adminWebinarChatLoader = async (args: any) => {
    const module = await import("../pages/admin/webinar-chat/AdminWebinarChatPage");
    return module.loader ? await (module.loader as any)(args) : null;
};

